<template>
  <div class="list-block">
    <div class="list-header">
      <span class="list-title">Hot Spots</span>
      <div class="header-right">
        <span class="count-pill">{{ hotSpots?.length || 0 }}</span>
      </div>
    </div>

    <div v-if="hotSpots && hotSpots.length > 0" class="result-list" :class="`view-${layout}`">
      <div v-for="hotSpot in hotSpots" :key="hotSpot.id" class="result-item">
        <HotSpotListItem :hotSpot="hotSpot" :asset="asset" :layout="layout" @onLocateHotSpotMarker="locateHotSpot" />
      </div>
    </div>

    <div v-else class="list-empty">
      <v-icon size="26" color="#4a5a60">mdi-fire-off</v-icon>
      <span>No hot spots in this area.</span>
    </div>
  </div>
</template>

<script>
import HotSpotListItem from '../list-items/HotSpotListItem.vue';

export default {
  name: "HotSpotList",
  components: {
    HotSpotListItem
  },
  emits: ['OnHotSpotSelected'],
  props: {
    hotSpots: {
      type: Array,
      default: () => []
    },
    asset: {
      type: Object,
      default: () => null,
      required: true,
    },
    layout: {
      type: String,
      default: 'list'   // 'list' | 'grid'
    },
  },
  methods: {
    locateHotSpot(marker) {
      this.$emit('OnHotSpotSelected', marker);
    }
  }
}
</script>

<style scoped>
.list-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 2px;
}

.list-title {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8aa0aa;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-pill {
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba(100, 255, 218, 0.1);
  border: 1px solid rgba(100, 255, 218, 0.25);
  color: var(--duallo-accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-list.view-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px;
  align-content: start;
}

.result-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.result-item:hover {
  background: rgba(100, 255, 218, 0.05);
  border-color: rgba(100, 255, 218, 0.15);
}

.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 20px 8px;
  color: #8aa0aa;
  font-size: 0.82rem;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
}
</style>
